import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { enableGA, initGA, logGAEvent } from '../../../utils/gtag';
import ButtonComponent from '../button.component';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const BannerContainer = styled.div`
  position: fixed;
  border-radius: 15px;
  bottom: 5%;
  left: 2%;
  border: 2px solid  #01904e;
  max-width: 365px;
  width: calc(100% - 4%);
  background-color: #fff;
  color: rgb(72, 72, 72);
  padding: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 18px;
  line-height: 24px;


   @media (max-width: 430px) {
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 14px 16px;
    max-width: 95%;
    left: 2.5%;
    right: 2.5%;
    width: auto;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 80%;
`;




const CookieBannerComponent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    initGA();
  
    const cookieAccepted = localStorage.getItem('cookieConsent');
  
    if (cookieAccepted === 'true') {
      enableGA();
    }
  
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
    enableGA();
    logGAEvent('cookie_accept', 'Cookie Banner', 'User accepted cookies');
  };
  
  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
    logGAEvent('cookie_decline', 'Cookie Banner', 'User declined cookies');
  };
  
  if (!isVisible) return null;

  return (
    <BannerContainer>
      🍪 Ми не зберігаємо дані, але використовуємо файли Cookies для правильної роботи контакт-центру.
      <ButtonsContainer>
        <ButtonComponent text='Прийняти' position='bottom-right' onClick={handleAccept}/>
         <ButtonComponent variant="outline" text='Відхилити' position='top-right' onClick={handleDecline}/>
      </ButtonsContainer>
    </BannerContainer>
  );
};

export default CookieBannerComponent;
